import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useTaskListFilter } from "../../../hooks/expert-task-list/ExpertTaskListFilterHook";
import { validateTaskFeeFilter } from "../../../hooks/expert-task-list/TaskListHelper";
import { useExpertProfileContext } from "../../../hooks/expert-profile/ExpertProfileContext";
import { createSuggestions } from "../../../../portal/utils/AutoCompleteDataUtil";
const ExpertTaskFilters = ({
  children
}) => {
  const {
    tasklistFilters,
    clearExpertTaskFilters,
    setTaskTypeFilters,
    setPassedTasksFilters,
    setSelectedGroups,
    applyFilters,
    renderFilterLabel,
    setFeeFilters,
    setTasklistFilters
  } = useTaskListFilter();
  const {
    profile: {
      groups = []
    }
  } = useExpertProfileContext();
  const {
    fieldErrors,
    isFormInvalid
  } = validateTaskFeeFilter(tasklistFilters.taskFee);
  const handleTaskTypeFilterChange = (name, value, checked) => {
    var _tasklistFilters$sele;
    setTaskTypeFilters(name, checked);
    const checkedFilterExist = tasklistFilters === null || tasklistFilters === void 0 ? void 0 : (_tasklistFilters$sele = tasklistFilters.selectedFilters) === null || _tasklistFilters$sele === void 0 ? void 0 : _tasklistFilters$sele.some(item => item.name === name);
    let updatedFilters;
    if (checked && !checkedFilterExist) {
      // If the checkbox is checked and the filter does not exist, add a new filter to the array
      updatedFilters = [...tasklistFilters.checkedFilters, {
        name,
        checked
      }];
    } else if (checkedFilterExist && !checked) {
      // If the checkbox is unchecked and the filter exists, remove the filter from the array
      updatedFilters = [...tasklistFilters.checkedFilters, {
        name,
        checked
      }];
      // updatedFilters = tasklistFilters.checkedFilters.filter(filter => filter.name !== name);
    } else {
      // If the checkbox is already checked or unchecked, keep the filters array unchanged
      updatedFilters = tasklistFilters.checkedFilters.filter(filter => filter.name !== name);
    }
    setTasklistFilters({
      ...tasklistFilters,
      checkedFilters: updatedFilters
    });
  };
  const handlePassedTaskFilterChange = (name, value, checked) => {
    setPassedTasksFilters(checked);
  };
  const handleApplyFilters = () => {
    let selectedFilters = [];
    Object.keys(tasklistFilters.taskType).map(filterKey => {
      const filter = tasklistFilters.taskType[filterKey];
      if (filter.value) {
        selectedFilters.push({
          ...filter,
          name: filterKey
        });
      }
    });
    selectedFilters = [...selectedFilters, ...tasklistFilters.selectedGroups.value];
    tasklistFilters.selectedFilters = [...selectedFilters, ...tasklistFilters.selectedGroups.value];
    if (tasklistFilters.taskFee.minFee && tasklistFilters.taskFee.minFee !== 0 || tasklistFilters.taskFee.maxFee && tasklistFilters.taskFee.maxFee !== 0) {
      selectedFilters.push({
        label: `${tasklistFilters.taskFee.minFee} - ${tasklistFilters.taskFee.maxFee}`,
        name: "Fee"
      });
      selectedFilters = [...selectedFilters, {
        minMsgFee: tasklistFilters.taskFee.minFee
      }];
      selectedFilters = [...selectedFilters, {
        maxMsgFee: tasklistFilters.taskFee.maxFee
      }];
      tasklistFilters.selectedFilters = [...selectedFilters];
    }
    if (tasklistFilters.passed) {
      selectedFilters = [...selectedFilters, {
        passed: true
      }];
      tasklistFilters.selectedFilters = [...selectedFilters];
    }
    setTasklistFilters({
      ...tasklistFilters,
      selectedFilters,
      pristine: false,
      checkedFilters: [],
      removedFilter: [],
      addFilter: []
    });
    applyFilters();
  };
  const handleClearAllFilters = () => {
    clearExpertTaskFilters();
  };
  const handleFeeFilterChange = (key, value) => {
    setFeeFilters(key, value);
  };
  const removeSelectedFilter = selectedFilter => {
    const remainingFilters = tasklistFilters.selectedFilters.filter(item => item.name !== selectedFilter.name || item.value !== selectedFilter.value);
    tasklistFilters.selectedFilters = remainingFilters;
    if (typeof selectedFilter.value === "boolean") {
      setTaskTypeFilters(selectedFilter.name, false);
    } else if (typeof selectedFilter.value === "undefined") {
      tasklistFilters.taskFee = {
        minFee: "",
        maxFee: ""
      };
    } else {
      const remainingGroups = tasklistFilters.selectedGroups.value.filter(item => item.groupName !== selectedFilter.groupName);
      tasklistFilters.selectedGroups = {
        ...tasklistFilters.selectedGroups,
        value: remainingGroups
      };
    }
    setTasklistFilters({
      ...tasklistFilters,
      selectedFilters: remainingFilters,
      isFilterSelected: remainingFilters.length === 0 ? false : true,
      pristine: remainingFilters.length === 0 ? true : false
    });
    applyFilters();
  };
  const groupByTenantName = React.useMemo(() => {
    const groupSuggestions = createSuggestions(groups, {
      labelDataKey: "displayName",
      valueDataKey: "groupName",
      includeItemObject: true
    });
    return groupSuggestions.filter(g => g.membershipState === "active").reduce((result, item) => ({
      ...result,
      [item["tenantDisplayName"]]: [...(result[item["tenantDisplayName"]] || []), item]
    }), {});
  }, [groups]);
  const isQualityReviewGroupFound = React.useMemo(() => {
    return groups.filter(g => (g === null || g === void 0 ? void 0 : g.qualityReviewGroup) === true);
  }, [groups]);
  return children({
    filters: tasklistFilters,
    isFilterSelected: tasklistFilters.isFilterSelected || !tasklistFilters.pristine,
    onGroupChange: setSelectedGroups,
    onTaskTypeFilterChange: handleTaskTypeFilterChange,
    onPassedTaskFilterChange: handlePassedTaskFilterChange,
    onClearFilters: handleClearAllFilters,
    onApplyFilters: handleApplyFilters,
    onRenderFilterLabel: renderFilterLabel,
    onFeeFilterChange: handleFeeFilterChange,
    fieldErrors,
    isFormInvalid,
    removeSelectedFilter,
    groupByTenantName,
    isQualityReviewGroupFound
  });
};
export default ExpertTaskFilters;
ExpertTaskFilters.propTypes = {
  children: PropTypes.func.isRequired
};